<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="item ? 'Sửa thẻ tag' : 'Thêm thẻ tag'"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="medium"
      label-position="top"
    >
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="name"
            label="Tên thẻ"
          >
            <el-input
              v-model="form.name"
              placeholder="Nhập tên"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="description"
            label="Mô tả"
          >
            <el-input
              v-model="form.description"
              type="textarea"
              placeholder="Nhập mô tả"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { notification, convertPayloadData } from "@/utils/common";
import tagServices from "@/services/tag";

export default {
  name: "DataFormPopup",
  props: {
    item: Object,
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      form: {
        name: "",
        description: "",
      },
      callingAPI: false,
    };
  },
  computed: {
    isCreate() {
      return !this.item || !this.item.id;
    },
    payloadData() {
      return convertPayloadData("tags", {
        id: this.item?.id || "",
        extra: {
          name: this.form.name,
          description: this.form.description,
        },
      });
    },
    rules() {
      const result = {
        name: [
          {
            required: true,
            message: `Tên thẻ là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ],
      };
      return result;
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      if (this.item) {
        this.form = {
          name: this.item.extra?.name || "",
          description: this.item.extra?.description || "",
        };
      } else {
        this.form = {
          name: "",
          description: "",
        };
      }
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          tagServices[!this.isCreate ? "update" : "create"](
            this.payloadData
          )
            .then(() => {
              this.callingAPI = false;
              this.$emit("reload");
              notification(
                this,
                "success",
                !this.isCreate ? "update" : "create",
                "thẻ tag"
              );
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                !this.isCreate ? "update" : "create",
                "thẻ tag"
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
</style>
